import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-[700px] mx-auto text-center">
          <h2 className="text-xl md:text-3xl font-heading text-foreground-950 mb-4">
            {contactData.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
            {contactData.description}
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="bg-background-100 rounded-lg border border-background-200/70 p-5 flex flex-col items-center gap-2">
              <div className="w-11 h-11 rounded-full bg-primary-100 flex items-center justify-center">
                <i className="ri-mail-line text-primary-600 text-lg"></i>
              </div>
              <span className="text-xs text-foreground-500">电子邮箱</span>
              <span className="text-sm font-medium text-foreground-950 break-all">
                {contactData.email}
              </span>
            </div>
            <div className="bg-background-100 rounded-lg border border-background-200/70 p-5 flex flex-col items-center gap-2">
              <div className="w-11 h-11 rounded-full bg-accent-100 flex items-center justify-center">
                <i className="ri-qq-line text-accent-600 text-lg"></i>
              </div>
              <span className="text-xs text-foreground-500">QQ 群号</span>
              <span className="text-sm font-medium text-foreground-950">{contactData.qq}</span>
            </div>
            <div className="bg-background-100 rounded-lg border border-background-200/70 p-5 flex flex-col items-center gap-2">
              <div className="w-11 h-11 rounded-full bg-secondary-100 flex items-center justify-center">
                <i className="ri-wechat-line text-secondary-600 text-lg"></i>
              </div>
              <span className="text-xs text-foreground-500">微信公众号</span>
              <span className="text-sm font-medium text-foreground-950">{contactData.wechat}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}